import { Environment } from "../app/models/env"

export const environment: Environment = {
	name: "staging",
	domain: "https://italgas-early-warning-platform-service-911-staging.mashfrogcloud.com",
	realEstateRoleGroup: "0dd2bf35-3858-4e86-b944-480b407b4754",
	msalConfig: {
		auth: {
			clientId: "e17491c0-b774-4209-83e5-0aa1cd73b0d0",
			clientScopeProtocol: "api://",
			clientScopeEndpoint: "/ewplatform",
			authority: "https://login.microsoftonline.com/a4d618cc-cf96-4e63-9d38-9185499aae90",
			redirectUri: "https://italgas-early-warning-platform-web-925-staging.mashfrogcloud.com/home",
			postLogoutRedirectUri: "https://italgas-early-warning-platform-web-925-staging.mashfrogcloud.com/",
			loginFailedRoute: "https://italgas-early-warning-platform-web-925-staging.mashfrogcloud.com/?error=true"
		},
		apiConfig: {
			scopes: ["User.Read"],
			uri: "https://graph.microsoft.com/v1.0/me"
		},
		disableAutoLogout: false,
		allowedGroups: null // ["960b5d7f-05c3-48b1-80a2-9fde447b4336"]
	},
	logger: {
		auth: true,
		emitter: false,
		info: true,
		warn: true,
		error: true,
		msalLogs: false,
		msalEvents: true,
		msalRoutes: true
	},
	map: {
		key: "AIzaSyCkrY67LBcQHVaRpEutwzOcy2YVjQcnggs",
		mapId: "c792e5e0c27f2810"
	},
	sosCheckInterval: 30 * 1000, // polling ogni 30s
	liveFeedCheckInterval: 30 * 1000 // polling ogni 30s
}
